import '../styles/ClickableButton.css';
import { ANIMATION_TYPES } from '../CONSTANTS'
import { useNavigate } from 'react-router';

export function BackButton () {

    let navigate = useNavigate();

    // Handle mouse-over animations
    function mouseEnter () {
        let button = document.getElementById('button-back')
        button.classList.add(ANIMATION_TYPES.SECONDARY)
        button.addEventListener('animationend', () => {
            button.classList.remove(ANIMATION_TYPES.SECONDARY)
        });
    }

    // Send user to the appropriate URL on click
    function onClick () {
        navigate('/')
    }

    return (
        <div 
            id='button-back'
            className='animate__animated'
            onMouseEnter={mouseEnter}
            onClick={onClick}
        >
            <button className='back-button'>
                <svg width="60" height="60" viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" transform="rotate(0 0 0)">
                    <path d="M2 12.5C2 6.97766 6.47729 2.50098 11.9996 2.50098C17.5218 2.50098 21.9991 6.97766 21.9991 12.5C21.9991 18.0224 17.5218 22.4991 11.9996 22.4991C6.47729 22.4991 2 18.0224 2 12.5ZM11.4982 9.15521C11.2178 9.03915 10.8952 9.10341 10.6808 9.31801L8.04259 11.9578C7.89904 12.0945 7.80957 12.2874 7.80957 12.5012C7.80957 12.7277 7.90996 12.9307 8.06867 13.0682L10.6807 15.6821C10.8952 15.8967 11.2178 15.961 11.4981 15.8449C11.7785 15.7289 11.9612 15.4554 11.9612 15.152V13.2512L15.4402 13.2512C15.8544 13.2512 16.1902 12.9154 16.1902 12.5012C16.1902 12.087 15.8544 11.7512 15.4402 11.7512H11.9612V9.84817C11.9612 9.54478 11.7785 9.27127 11.4982 9.15521Z"/>
                </svg>
            </button>
        </div>
    )
}